module.exports = __webpack_public_path__ + "static/media/bt.bde3270a.png";